export default "__VITE_PUBLIC_ASSET__fa514f7a__"